import React, { useEffect, useRef, useState } from "react";
import axiosInstance from "../../utils/axios";
import EntityManagement from "../../components/formTemplates/EntityManagement";
import EntityTable from "../../components/templateComponents/EntityTable";
import useDropdownFetch from "../../components/apiFetch/useDropdownFetch";

const Unit = () => {
  const [formData, setFormData] = useState({
    establishment_id: "",
    campusid: "",
    bldg_id: "",
    bldg_fid: "",
    bldg_sid: "",
    unittype_id: "",
    bldg_unit: "",
    bldg_unitname: "",
    sqft: "",
    status_id: "",
  });

  const [entities, setEntities] = useState([]);
  const [dropdownData, setDropdownData] = useState({
    establishment_id: [],
    campusid: [],
    bldg_id: [],
    bldg_fid: [],
    bldg_sid: [],
    unittype_id: [],
    status_id: [],
  });

  const [editMode, setEditMode] = useState(false);
  const [editingEntityId, setEditingEntityId] = useState(null);
  const [isTableModalOpen, setIsTableModalOpen] = useState(false);
  const [selectedEstId, setSelectedEstId] = useState("");
  const [selectedCampusId, setSelectedCampusId] = useState("");
  const [selectedBldgId, setSelectedBldgId] = useState("");

  const firstFormFieldRef = useRef(null);

 
  const endpoints = {
    establishments: "/view_establishment/v1.1",
    campuses: "/view_campus/v1.1",
    buildings: "/view_building/v1.1",
    floors: "/view_floor/v1.1",
    sections: "/view_section/v1.1",
    units: "/view_unit/v1.1",
    registerUnit: "/registration_unit/v1.1",
    updateUnit: "/update_unit/v1.1",
    unittype: "/view_unittype/v1.1",
    status: "/view_status/v0.1",
  };

 
  useEffect(() => {
    // Establishments
    axiosInstance
      .post(endpoints.establishments, { area_id: 1, view_type: "view" })
      .then((res) =>
        setDropdownData((prev) => ({
          ...prev,
          establishment_id: Object.entries(res.data.Data || {}).map(([value, label]) => ({
            value,
            label,
          })),
        }))
      )
      .catch(() => {});

    // Sections
    axiosInstance
      .post(endpoints.sections, { view_type: "view" })
      .then((res) =>
        setDropdownData((prev) => ({
          ...prev,
          bldg_sid: Object.entries(res.data.Data || {}).map(([value, label]) => ({
            value,
            label,
          })),
        }))
      )
      .catch(() => {});

    // Unit Types
    axiosInstance
      .post(endpoints.unittype, { view_type: "view" })
      .then((res) =>
        setDropdownData((prev) => ({
          ...prev,
          unittype_id: Object.entries(res.data.Data || {}).map(([value, label]) => ({
            value,
            label,
          })),
        }))
      )
      .catch(() => {});
  }, []);

  
  const { options: statusOptions } = useDropdownFetch(endpoints.status);
  useEffect(() => {
    if (statusOptions) {
      setDropdownData((prev) => ({ ...prev, status_id: statusOptions }));
    }
  }, [statusOptions]);

  
  useEffect(() => {
    if (!formData.establishment_id) {
      setDropdownData((prev) => ({ ...prev, campusid: [] }));
      return;
    }
    axiosInstance
      .post(endpoints.campuses, { est_id: formData.establishment_id, view_type: "view" })
      .then((res) =>
        setDropdownData((prev) => ({
          ...prev,
          campusid: Object.entries(res.data.Data || {}).map(([value, label]) => ({ value, label })),
        }))
      )
      .catch(() => {});
  }, [formData.establishment_id]);

  useEffect(() => {
    if (!formData.campusid) {
      setDropdownData((prev) => ({ ...prev, bldg_id: [] }));
      return;
    }
    axiosInstance
      .post(endpoints.buildings, { campusid: formData.campusid, view_type: "view" })
      .then((res) =>
        setDropdownData((prev) => ({
          ...prev,
          bldg_id: Object.entries(res.data.Data || {}).map(([value, label]) => ({ value, label })),
        }))
      )
      .catch(() => {});
  }, [formData.campusid]);

  useEffect(() => {
    if (!formData.bldg_id) {
      setDropdownData((prev) => ({ ...prev, bldg_fid: [] }));
      return;
    }
    axiosInstance
      .post(endpoints.floors, { bldg_id: parseInt(formData.bldg_id), view_type: "view" })
      .then((res) =>
        setDropdownData((prev) => ({
          ...prev,
          bldg_fid: Object.entries(res.data.Data || {}).map(([value, label]) => ({ value, label })),
        }))
      )
      .catch(() => {});
  }, [formData.bldg_id]);


  useEffect(() => {
    if (!selectedEstId) {
      setDropdownData((prev) => ({ ...prev, campusid: [] }));
      return;
    }
    axiosInstance
      .post(endpoints.campuses, { est_id: selectedEstId, view_type: "view" })
      .then((res) =>
        setDropdownData((prev) => ({
          ...prev,
          campusid: Object.entries(res.data.Data || {}).map(([value, label]) => ({ value, label })),
        }))
      )
      .catch(() => {});
  }, [selectedEstId]);

  useEffect(() => {
    if (!selectedCampusId) {
      setDropdownData((prev) => ({ ...prev, bldg_id: [] }));
      return;
    }
    axiosInstance
      .post(endpoints.buildings, { campusid: selectedCampusId, view_type: "view" })
      .then((res) =>
        setDropdownData((prev) => ({
          ...prev,
          bldg_id: Object.entries(res.data.Data || {}).map(([value, label]) => ({ value, label })),
        }))
      )
      .catch(() => {});
  }, [selectedCampusId]);

  
  useEffect(() => {
    if (isTableModalOpen && selectedBldgId) {
      fetchUnits(selectedBldgId);
    } else if (isTableModalOpen) {
      setEntities([]);
    }
  }, [selectedBldgId, isTableModalOpen]);

  
  const fetchUnits = async (bldgId) => {
    if (!bldgId) return setEntities([]);
    try {
      const res = await axiosInstance.post(endpoints.units, {
        view_type: "view all",
        bldg_id: parseInt(bldgId),
      });
      setEntities(Array.isArray(res.data?.Data) ? res.data.Data : []);
    } catch {
      setEntities([]);
    }
  };

 
  const handleViewTableClick = () => {
    if (!selectedEstId && formData.establishment_id) setSelectedEstId(formData.establishment_id);
    if (!selectedCampusId && formData.campusid) setSelectedCampusId(formData.campusid);
    if (!selectedBldgId && formData.bldg_id) setSelectedBldgId(formData.bldg_id);
    setIsTableModalOpen(true);
  };


  const handleFormSubmit = async (e) => {
  e.preventDefault();
  const payload = {
    bldg_id: parseInt(formData.bldg_id),
    bldg_fid: parseInt(formData.bldg_fid), 
    bldg_sid: parseInt(formData.bldg_sid),
    unittype_id: parseInt(formData.unittype_id),
    bldg_unit: formData.bldg_unit,
    bldg_unitname: formData.bldg_unitname,
    sqft: parseFloat(formData.sqft),
    status_id: parseInt(formData.status_id),
  };
  try {
    if (editMode) {
      await handleUpdate(editingEntityId, payload);
    } else {
      const res = await axiosInstance.post(endpoints.registerUnit, payload);
      if (res.data.Status === "Success") {
        await fetchUnits(selectedBldgId || formData.bldg_id);
        resetForm();
      }
    }
  } catch (error) {
    console.error("Error adding/updating unit:", error);
  }
};

const handleUpdate = async (id, payload) => {
  try {
    const updatePayload = {
      bldg_id: payload.bldg_id,
      bldg_floor: payload.bldg_fid,
      bldg_section: payload.bldg_sid,
      unittype_id: payload.unittype_id,
      bldg_unit: payload.bldg_unit,
      bldg_unitname: payload.bldg_unitname,
      sqft: payload.sqft,
      status_id: payload.status_id,
      bldg_uid: id,
    };

    const res = await axiosInstance.post(endpoints.updateUnit, updatePayload);
    if (res.data.Status === "Success") {
      await fetchUnits(selectedBldgId || formData.bldg_id);
      resetForm();
      setIsTableModalOpen(false);
    }
  } catch (err) {
    console.error("Error updating unit:", err);
  }
};


  const handleEdit = (id) => {
    const entity = entities.find((e) => e && e.bldg_uid === id);
    if (entity) {
      setFormData({
        establishment_id: entity.establishment_id || "",
        campusid: entity.campusid || "",
        bldg_id: entity.bldg_id || "",
        bldg_fid: entity.bldg_fid || "",
        bldg_sid: entity.bldg_sid || "",
        unittype_id: entity.unittype_id || "",
        bldg_unit: entity.bldg_unit || "",
        bldg_unitname: entity.bldg_unitname || "",
        sqft: entity.sqft || "",
        status_id: entity.status_id || "",
      });
      setEditMode(true);
      setEditingEntityId(id);
      setIsTableModalOpen(false);
    }
  };

 
  const resetForm = () => {
    setFormData({
      establishment_id: "",
      campusid: "",
      bldg_id: "",
      bldg_fid: "",
      bldg_sid: "",
      unittype_id: "",
      bldg_unit: "",
      bldg_unitname: "",
      sqft: "",
      status_id: "",
    });
    setEditMode(false);
    setEditingEntityId(null);
  };

 
  const formFields = [
    { name: "bldg_unit", label: "Unit Code/Number", type: "text", required: true },
    { name: "establishment_id", label: "Establishment", type: "select", dropdownKey: "establishment_id", required: true },
    { name: "campusid", label: "Campus", type: "select", dropdownKey: "campusid", required: true },
    { name: "bldg_id", label: "Building", type: "select", dropdownKey: "bldg_id", required: true },
    { name: "bldg_fid", label: "Floor", type: "select", dropdownKey: "bldg_fid", required: true },
    { name: "bldg_sid", label: "Section", type: "select", dropdownKey: "bldg_sid", required: true },
    { name: "unittype_id", label: "Unit Type", type: "select", dropdownKey: "unittype_id", required: true },
    { name: "bldg_unitname", label: "Unit Name", type: "text", required: true },
    { name: "sqft", label: "Sqft", type: "number", required: true },
    { name: "status_id", label: "Status", type: "select", dropdownKey: "status_id", required: true },
  ];

 
  const columns = [
    { name: "bldg_uid", label: "Unit ID" },
    { name: "bldg_unit", label: "Unit Code/Number" },
    { name: "bldg_unitname", label: "Unit Name" },
    { name: "bldg_name", label: "Building" },
    { name: "bldg_floorname", label: "Floor" },
    { name: "bldg_section_name", label: "Section" },
    { name: "typename", label: "Unit Type" },
    { name: "sqft", label: "Sqft" },
    { name: "status_name", label: "Status" },
  ];

  
  const dropdownStyle = {
    padding: "10px 14px",
    fontSize: "14px",
    border: "1px solid #d1d5db",
    borderRadius: "6px",
    width: "200px",
    backgroundColor: "#fff",
    color: "#111827",
    appearance: "none",
    backgroundSize: "1rem",
    cursor: "pointer",
    transition: "border-color 0.2s ease, boxShadow 0.2s ease",
  };
  const labelStyle = {
    fontWeight: "600",
    marginBottom: "0.6rem",
    fontSize: "14px",
    color: "#374151",
  };


  const safeEntities = (entities || []).filter((item) => item && item.bldg_uid != null);

  return (
    <div className="units">
      <EntityManagement
        entityName="Unit"
        formFields={formFields}
        formData={formData}
        setFormData={setFormData}
        handleFormSubmit={handleFormSubmit}
        dropdownData={dropdownData}
        setDropdownData={setDropdownData}
        firstFormFieldRef={firstFormFieldRef}
        handleViewTableClick={handleViewTableClick}
        onEdit={handleEdit}
      />

      {isTableModalOpen && (
        <div className="modal">
          <div className="modal-content" style={{ maxWidth: 900, margin: "auto" }}>
            <button onClick={() => setIsTableModalOpen(false)}>Close</button>

            <div
              style={{
                display: "flex",
                gap: "2rem",
                marginBottom: "1.5rem",
                backgroundColor: "#f9fafb",
                padding: "1rem",
                borderRadius: "8px",
                boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
                border: "1px solid #e5e7eb",
                justifyContent: "center",
              }}
            >
              <div style={{ display: "flex", flexDirection: "column" }}>
                <label style={labelStyle}>Filter by Establishment:</label>
                <select
                  value={selectedEstId}
                  onChange={(e) => {
                    setSelectedEstId(e.target.value);
                    setSelectedCampusId("");
                    setSelectedBldgId("");
                  }}
                  style={dropdownStyle}
                >
                  <option value="">All</option>
                  {dropdownData.establishment_id.map(({ value, label }) => (
                    <option key={value} value={value}>
                      {label}
                    </option>
                  ))}
                </select>
              </div>

              <div style={{ display: "flex", flexDirection: "column" }}>
                <label style={labelStyle}>Filter by Campus:</label>
                <select
                  value={selectedCampusId}
                  onChange={(e) => {
                    setSelectedCampusId(e.target.value);
                    setSelectedBldgId("");
                  }}
                  style={dropdownStyle}
                >
                  <option value="">All</option>
                  {dropdownData.campusid.map(({ value, label }) => (
                    <option key={value} value={value}>
                      {label}
                    </option>
                  ))}
                </select>
              </div>

              <div style={{ display: "flex", flexDirection: "column" }}>
                <label style={labelStyle}>Filter by Building:</label>
                <select
                  value={selectedBldgId}
                  onChange={(e) => setSelectedBldgId(e.target.value)}
                  style={dropdownStyle}
                >
                  <option value="">All</option>
                  {dropdownData.bldg_id.map(({ value, label }) => (
                    <option key={value} value={value}>
                      {label}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <EntityTable
              data={safeEntities}
              columns={columns}
              onEdit={handleEdit}
              keyField="bldg_uid"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Unit;
